import { Component } from "@angular/core";
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../auth/auth.service";
import { environment } from "../../../environments/environment";
import { AuthMsgService } from "src/auth/auth-msg.service";

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private msgService: AuthMsgService
  ) {}

  ngOnInit(): void {
    this.msgService.hideSideNav(true);
    this.router.navigate(["/cases"]);
  
  }
}
